<div class="modal-content" piqetAngularDraggable>
  <div class="modal-header">
    <h2 class="modal-title ml-auto pl-5" id="exampleModalLabel">
      <div class="bootstrap-dialog-title" id="dialogMaterialCreate_title">{{ modalLabel }}</div>
    </h2>

    <button type="button" class="closeModal pull-right" aria-label="Close" (click)="onClose()">
      <img src="./assets/icons/pop-up-cross.svg" width="16" height="17" />
    </button>
  </div>
  <div class="modal-body body-modal">
    <form
      [formGroup]="manageProjectWorkflowAddEditForm"
      [ngClass]="{ 'disabled-popup': !checkEntireAccess }"
    >
      <div class="row">
        <div class="col-sm-12">
          <div *ngIf="isShowError" class="alert alert-danger" aria-required="true">
            <p>The value '{{ positionval }}' is not valid</p>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-sm-12">
          <div class="form-group required" aria-required="true">
            <piqet-angular-common-input
              formControlName="label"
              [control]="manageProjectWorkflowAddEditForm.get('label')"
              label="Label"
              placeholder="Label"
              [maxLength]="50"
              [submitted]="submitted"
            >
            </piqet-angular-common-input>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-12">
          <div class="form-group required" aria-required="true">
            <piqet-angular-common-input
              formControlName="position"
              [control]="manageProjectWorkflowAddEditForm.get('position')"
              label="Position"
              placeholder="Position"
              [maxLength]="10"
              inputType="number"
              [minValue]="1"
              [preventNegative]="true"
              [enableRangeValidation]="true"
              [submitted]="submitted"
            >
            </piqet-angular-common-input>
          </div>
        </div>
      </div>
      <div class="row checkbox-text-margin">
        <div class="col-sm-2 mt-2" class="checkbox-text checkBoxAlienMent">
          <input
            type="checkbox"
            class="chkOverview"
            [ngModelOptions]="{ standalone: true }"
            [(ngModel)]="isPublicValue"
            (change)="isPublic($event)"
          />
          <span> Public</span>
        </div>
      </div>
    </form>
  </div>
  <div class="modal-footer">
    <button type="button" class="cancelBtn" (click)="onClose()">Cancel</button>
    <button
      type="button"
      class="modelBtn purpleBtnHoverEffect"
      (click)="onSave()"
      *ngIf="checkEntireAccess"
    >
      Save
    </button>
  </div>
</div>
